/*-------------  SLIDE 2 animation  -------------*/

function slide2_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';

	 $(".slide").html('');

		bmcont = '<div id="moveHome"></div><div id="sl2_cnt" class="s2_cnt"></div><div id="sl2_foo" class="menu_bott"></div>';

		$("#slide2").html(bmcont);

		homepage = '<div id="moveHead"><span class="head-icon"></span><h1>'+jsondata["sl2_head"]+'</h1></div>';
		$("#moveHome").html(homepage);

    $('#slide2').fadeIn(1000);

    returnHome('#moveHome','.slide','');

    bmcont = '<div id="animate2">';
		pocet = jsondata["sl2_point"].length + 1;
		for (i=1; i<pocet; i++) {

      point = "<div class='circle_pos' id='circle_pos_"+i+"' data-clicked='"+i+"'>";
			point += "<div class='circle_leash' id='circle_leash_"+i+"'></div>";
			point += "<div class='circle_label' id='circle_label_"+i+"'>"+jsondata["sl2_point"][i-1]+"</div>";
			point += "<div class='circle_bg'></div>";
			point += "<div class='circle_anim pulsateME'></div>";
			point += "<div class='circle' id='circle_"+i+"' data-clicked='"+i+"'><span class='circle_number'>"+i+"</span></div>";
			point += "<div class='circle_over' id='circle_over_"+i+"' data-clicked='"+i+"'></div>";
			point += "</div>";

	 	bmcont += point;
		}
		bmcont += '</div>'
    $("#sl2_cnt").html(bmcont);

    bmcont = '';
    pocet = jsondata["sl2_banner"].length;
    for (i=1; i<pocet; i++) {
      bmcont += jsondata["sl2_banner"][i];
    }

    $("#banner_box").html(bmcont);
    $("#banner_box").css( "z-index", "1" );

    $(".circle_pos").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "circle_pos_1":
        slide21_anima();
			break;
			case "circle_pos_2":
        var bannerBox2 = document.getElementById("sl2_banner2");
        TweenMax.to(bannerBox2, 1, {x:0, y:545,  ease:Quint.easeOut});
        TweenMax.to(bannerBox2, 0.5, {autoAlpha:1});
        var bannerBox1 = document.getElementById("sl2_banner3");
        TweenMax.to(bannerBox1, 1, {x:0, y:-425,  ease:Quint.easeOut});
        TweenMax.to(bannerBox1, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "10" );
			break;
			case "circle_pos_3":
        var bannerBox1 = document.getElementById("sl2_banner3");
        TweenMax.to(bannerBox1, 1, {x:0, y:545,  ease:Quint.easeOut});
        TweenMax.to(bannerBox1, 0.5, {autoAlpha:1});
        var bannerBox2 = document.getElementById("sl2_banner2");
        TweenMax.to(bannerBox2, 1, {x:0, y:-425,  ease:Quint.easeOut});
        TweenMax.to(bannerBox2, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "10" );
			break;
			case "circle_pos_4":
				slide22_anima();
			break;
		  };
    });

    $(".banner_close").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "sl2_banner2_close":
        var bannerBox2 = document.getElementById("sl2_banner2");
        TweenMax.to(bannerBox2, 1, {x:0, y:-425,  ease:Quint.easeOut});
        TweenMax.to(bannerBox2, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "1" );
			break;
			case "sl2_banner3_close":
        var bannerBox1 = document.getElementById("sl2_banner3");
        TweenMax.to(bannerBox1, 1, {x:0, y:-425,  ease:Quint.easeOut});
        TweenMax.to(bannerBox1, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "1" );
			break;
		  };
    });

}
